// Mock data for Chico da Inclusão Landing Page

export const heroData = {
  title: "Gestão da Inclusão e Acessibilidade nas Organizações",
  subtitle: "Transformando ambientes corporativos através de práticas inclusivas que garantem oportunidades iguais para pessoas com deficiência",
  ctaText: "Falar com Especialista",
  image: "https://images.unsplash.com/photo-1758873268631-fa944fc5cad2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHx3b3JrcGxhY2UlMjBkaXZlcnNpdHklMjBpbmNsdXNpb258ZW58MHx8fHwxNzc1MjU0MTkyfDA&ixlib=rb-4.1.0&q=85"
};

export const missionVisionData = {
  mission: {
    title: "Missão",
    description: "Promover a inclusão social de pessoas com deficiência por meio de treinamentos especializados, capacitando organizações e profissionais a adotarem práticas inclusivas e acessíveis que garantam oportunidades iguais de participação."
  },
  vision: {
    title: "Visão",
    description: "Ser referência em treinamento e capacitação sobre inclusão de pessoas com deficiência, contribuindo para uma sociedade mais justa, equitativa e sem barreiras, onde todas as pessoas sejam respeitadas e tenham suas potencialidades reconhecidas."
  },
  values: [
    {
      title: "Diversidade e Inclusão",
      description: "Respeito à diversidade humana em todas as suas formas"
    },
    {
      title: "Inovação",
      description: "Soluções criativas para acessibilidade e inclusão"
    },
    {
      title: "Transparência",
      description: "Comunicação clara e responsabilidade"
    },
    {
      title: "Compromisso Social",
      description: "Transformação de organizações em ambientes melhores"
    }
  ]
};

export const servicesData = [
  {
    id: 1,
    title: "Palestras",
    description: "Palestras inspiradoras e informativas sobre inclusão, diversidade e acessibilidade para sensibilizar equipes e lideranças.",
    icon: "Presentation"
  },
  {
    id: 2,
    title: "Treinamentos",
    description: "Capacitações práticas e especializadas para implementar políticas inclusivas efetivas em sua organização.",
    icon: "GraduationCap"
  },
  {
    id: 3,
    title: "Cursos",
    description: "Programas estruturados de aprendizado sobre legislação, boas práticas e gestão da inclusão.",
    icon: "BookOpen"
  },
  {
    id: 4,
    title: "Eventos Corporativos",
    description: "Eventos customizados como Jornada pela Inclusão, Café Sensorial e SIPAT com foco em inclusão.",
    icon: "Users"
  },
  {
    id: 5,
    title: "Programa de Letramento em D&I",
    description: "Programa completo para desenvolver competências em Diversidade e Inclusão em todos os níveis organizacionais.",
    icon: "Award"
  },
  {
    id: 6,
    title: "Consultoria",
    description: "Assessoria estratégica para diagnóstico, planejamento e implementação de práticas inclusivas.",
    icon: "Briefcase"
  }
];

export const eventsData = [
  {
    id: 1,
    title: "Jornada pela Inclusão da Pessoa com Deficiência",
    description: "Evento imersivo que promove a conscientização sobre os desafios e potencialidades das pessoas com deficiência no ambiente corporativo."
  },
  {
    id: 2,
    title: "Café Sensorial",
    description: "Experiência sensorial que permite aos participantes compreenderem melhor as diferentes formas de percepção do mundo."
  },
  {
    id: 3,
    title: "SIPAT - Inclusão e Acessibilidade",
    description: "Programação especial para Semana Interna de Prevenção de Acidentes do Trabalho com foco em inclusão e segurança."
  }
];

export const aboutData = {
  name: "Francisco Rodrigues Neto",
  nickname: "Chico da Inclusão",
  title: "Consultor, Palestrante e Educador",
  bio: "Especialista em gestão da inclusão e acessibilidade com vasta experiência na capacitação de organizações públicas e privadas. Autor, educador e defensor dos direitos das pessoas com deficiência, Francisco tem dedicado sua carreira a transformar ambientes corporativos em espaços mais justos e acessíveis.",
  credentials: [
    "Consultor especializado em Inclusão e Acessibilidade",
    "Palestrante com mais de 500 eventos realizados",
    "Autor de publicações sobre inclusão e diversidade",
    "Professor e educador em instituições de ensino",
    "Premiado pelo Governo do Estado de São Paulo - Ações Inclusivas 2011"
  ],
  image: "/francisco-photo.jpg"
};

export const alignmentData = {
  title: "Práticas Alinhadas com ESG e ODS",
  description: "Nossos serviços estão alinhados com as melhores práticas de ESG (Environmental, Social, Governance) e com os Objetivos de Desenvolvimento Sustentável da ONU.",
  goals: [
    {
      number: "8",
      title: "Trabalho Decente e Crescimento Econômico"
    },
    {
      number: "10",
      title: "Redução das Desigualdades"
    },
    {
      number: "16",
      title: "Paz, Justiça e Instituições Eficazes"
    }
  ]
};

export const partnersData = {
  title: "Parceiros e Clientes",
  partners: [
    "Colombo Agroindústria",
    "UNIFIPA",
    "Fundação Padre Albino",
    "Fatec Taquaritinga",
    "Fatec Catanduva",
    "Instituto Federal Catanduva",
    "Unimed Catanduva",
    "Prefeitura de Catanduva",
    "Câmara Municipal de Catanduva",
    "SESCOOP/SP"
  ]
};

export const statsData = [
  {
    value: "51%",
    label: "Mulheres no Brasil"
  },
  {
    value: "10%",
    label: "LGBTQIAP+"
  },
  {
    value: "56%",
    label: "Negros e Pardos"
  },
  {
    value: "24%",
    label: "Pessoas com Deficiência"
  }
];

export const contactData = {
  title: "Entre em Contato",
  subtitle: "Pronto para transformar sua organização em um ambiente mais inclusivo e acessível?",
  phone: "+55 17 99783-3002",
  email: "chicodainclusao@gmail.com",
  website: "www.chicodainclusao.com.br",
  social: {
    instagram: "https://www.instagram.com/chico_da_inclusao?igsh=MWtkMmp4NWNpYzF0",
    facebook: "https://www.facebook.com/share/1CVC1117ub/",
    linkedin: "chicodainclusao",
    youtube: "chicodainclusao"
  }
};
